import { handleErrors, URL } from "./depannageActions"
import { catchApiError, normalizeApiError } from "./apiHelpers"
import { getParams } from "../../utilities/Addons"

export const FETCH_DISPATCH_EN_ATTENTE_BEGIN = "FETCH_DISPATCH_EN_ATTENTE_BEGIN"
export const FETCH_DISPATCH_EN_ATTENTE_SUCCESS =
	"FETCH_DISPATCH_EN_ATTENTE_SUCCESS"
export const FETCH_DISPATCH_EN_ATTENTE_ERROR = "FETCH_DISPATCH_EN_ATTENTE_ERROR"
export const FETCH_DISPATCH_EN_ATTENTE_RESET = "FETCH_DISPATCH_EN_ATTENTE_RESET"

export const fetchDispatchEnAttenteBegin = () => ({
	type: FETCH_DISPATCH_EN_ATTENTE_BEGIN,
})

export const fetchDispatchEnAttenteSuccess = (depannages) => ({
	type: FETCH_DISPATCH_EN_ATTENTE_SUCCESS,
	payload: depannages,
})

export const fetchDispatchEnAttenteError = (error) => ({
	type: FETCH_DISPATCH_EN_ATTENTE_ERROR,
	payload: error,
})

export const fetchDispatchEnAttenteReset = (dispatch) => {
	return (dispatch) => {
		dispatch({
			type: FETCH_DISPATCH_EN_ATTENTE_RESET,
		})
		return Promise.resolve()
	}
}

export function fetchDispatchEnAttente() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		// Poll : au logout le token est vidé ; ne pas partir avec un header
		// `Bearer ` malformé (warning navigateur) — la requête 401 est inutile.
		if (!token) return Promise.resolve()
		let url = `${URL}api/dep_missions_planning?type=en_attente`
		dispatch(fetchDispatchEnAttenteBegin())
		return fetch(url, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDispatchEnAttenteSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDispatchEnAttenteError))
	}
}

export const FETCH_DISPATCH_EN_COURS_BEGIN = "FETCH_DISPATCH_EN_COURS_BEGIN"
export const FETCH_DISPATCH_EN_COURS_SUCCESS = "FETCH_DISPATCH_EN_COURS_SUCCESS"
export const FETCH_DISPATCH_EN_COURS_ERROR = "FETCH_DISPATCH_EN_COURS_ERROR"
export const FETCH_DISPATCH_EN_COURS_RESET = "FETCH_DISPATCH_EN_COURS_RESET"

export const fetchDispatchEnCoursBegin = () => ({
	type: FETCH_DISPATCH_EN_COURS_BEGIN,
})

export const fetchDispatchEnCoursSuccess = (depannages) => ({
	type: FETCH_DISPATCH_EN_COURS_SUCCESS,
	payload: depannages,
})

export const fetchDispatchEnCoursError = (error) => ({
	type: FETCH_DISPATCH_EN_COURS_ERROR,
	payload: error,
})

export const fetchDispatchEnCoursReset = (dispatch) => {
	return (dispatch) => {
		dispatch({
			type: FETCH_DISPATCH_EN_COURS_RESET,
		})
		return Promise.resolve()
	}
}

// Revue phase B (🟠4) : requêtes numérotées — une réponse plus ancienne que
// la dernière lancée (2 sondages + WS en parallèle) est ignorée.
let numeroEnCours = 0
export function fetchDispatchEnCours() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return Promise.resolve()
		let url = `${URL}api/dep_missions_planning?type=en_cours`
		const numero = ++numeroEnCours
		dispatch(fetchDispatchEnCoursBegin())
		return fetch(url, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				if (numero !== numeroEnCours) return
				dispatch(fetchDispatchEnCoursSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDispatchEnCoursError))
	}
}

export const FETCH_DEPANNAGES_TO_DISPATCH_BEGIN =
	"FETCH_DEPANNAGES_TO_DISPATCH_BEGIN"
export const FETCH_DEPANNAGES_TO_DISPATCH_SUCCESS =
	"FETCH_DEPANNAGES_TO_DISPATCH_SUCCESS"
export const FETCH_DEPANNAGES_TO_DISPATCH_ERROR =
	"FETCH_DEPANNAGES_TO_DISPATCH_ERROR"
export const FETCH_DEPANNAGES_TO_DISPATCH_RESET =
	"FETCH_DEPANNAGES_TO_DISPATCH_RESET"

export const fetchDepannageToDispatchBegin = () => ({
	type: FETCH_DEPANNAGES_TO_DISPATCH_BEGIN,
})

export const fetchDepannageToDispatchSuccess = (depannages) => ({
	type: FETCH_DEPANNAGES_TO_DISPATCH_SUCCESS,
	payload: depannages,
})

export const fetchDepannageToDispatchError = (error) => ({
	type: FETCH_DEPANNAGES_TO_DISPATCH_ERROR,
	payload: error,
})

export const fetchDepannageToDispatchReset = (dispatch) => {
	return (dispatch) => {
		dispatch({
			type: FETCH_DEPANNAGES_TO_DISPATCH_RESET,
		})
		return Promise.resolve()
	}
}

export function fetchDepannageToDispatch(params = null) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return Promise.resolve()
		let url = `${URL}api/depannages-dispatch`
		if (params) {
			url += getParams(params)
		}
		dispatch(fetchDepannageToDispatchBegin())
		return fetch(url, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDepannageToDispatchSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDepannageToDispatchError))
	}
}

export const FETCH_DM_PLANNING_EN_SUSPENS_BEGIN =
	"FETCH_DM_PLANNING_EN_SUSPENS_BEGIN"
export const FETCH_DM_PLANNING_EN_SUSPENS_SUCCESS =
	"FETCH_DM_PLANNING_EN_SUSPENS_SUCCESS"
export const FETCH_DM_PLANNING_EN_SUSPENS_ERROR =
	"FETCH_DM_PLANNING_EN_SUSPENS_ERROR"
export const FETCH_DM_PLANNING_EN_SUSPENS_RESET =
	"FETCH_DM_PLANNING_EN_SUSPENS_RESET"

export const fetchDmPlanningEnSuspensBegin = () => ({
	type: FETCH_DM_PLANNING_EN_SUSPENS_BEGIN,
})

export const fetchDmPlanningEnSuspensSuccess = (payload) => ({
	type: FETCH_DM_PLANNING_EN_SUSPENS_SUCCESS,
	payload,
})

export const fetchDmPlanningEnSuspensError = (error) => ({
	type: FETCH_DM_PLANNING_EN_SUSPENS_ERROR,
	payload: error,
})

export const fetchDmPlanningEnSuspensReset = (dispatch) => {
	return (dispatch) => {
		dispatch({
			type: FETCH_DM_PLANNING_EN_SUSPENS_RESET,
		})
		return Promise.resolve()
	}
}

let numeroEnSuspens = 0
let numeroRdv = 0

export function fetchDmPlanningEnSuspens() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return Promise.resolve()
		let url = `${URL}api/dep_missions_planning?type=en_suspens`
		// Revue 5 (🟡) : numérotée comme en_cours (sondage + WS + drop :
		// une réponse dépassée ne remplace pas la plus récente).
		const numero = ++numeroEnSuspens
		dispatch(fetchDmPlanningEnSuspensBegin())
		return fetch(url, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				if (numero !== numeroEnSuspens) return
				dispatch(fetchDmPlanningEnSuspensSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDmPlanningEnSuspensError))
	}
}

export const FETCH_DM_PLANNING_RDV_BEGIN = "FETCH_DM_PLANNING_RDV_BEGIN"
export const FETCH_DM_PLANNING_RDV_SUCCESS = "FETCH_DM_PLANNING_RDV_SUCCESS"
export const FETCH_DM_PLANNING_RDV_ERROR = "FETCH_DM_PLANNING_RDV_ERROR"
export const FETCH_DM_PLANNING_RDV_RESET = "FETCH_DM_PLANNING_RDV_RESET"

export const fetchDmPlanningRdvBegin = () => ({
	type: FETCH_DM_PLANNING_RDV_BEGIN,
})

export const fetchDmPlanningRdvSuccess = (payload) => ({
	type: FETCH_DM_PLANNING_RDV_SUCCESS,
	payload,
})

export const fetchDmPlanningRdvError = (error) => ({
	type: FETCH_DM_PLANNING_RDV_ERROR,
	payload: error,
})

export const fetchDmPlanningRdvReset = (dispatch) => {
	return (dispatch) => {
		dispatch({
			type: FETCH_DM_PLANNING_RDV_RESET,
		})
		return Promise.resolve()
	}
}

export function fetchDmPlanningRdv() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return Promise.resolve()
		let url = `${URL}api/dep_missions_planning?type=rendez_vous`
		const numero = ++numeroRdv
		dispatch(fetchDmPlanningRdvBegin())
		return fetch(url, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				if (numero !== numeroRdv) return
				dispatch(fetchDmPlanningRdvSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDmPlanningRdvError))
	}
}

export const FETCH_DISPATCH_ANNULEES_BEGIN = "FETCH_DISPATCH_ANNULEES_BEGIN"
export const FETCH_DISPATCH_ANNULEES_SUCCESS = "FETCH_DISPATCH_ANNULEES_SUCCESS"
export const FETCH_DISPATCH_ANNULEES_ERROR = "FETCH_DISPATCH_ANNULEES_ERROR"

export const fetchDispatchAnnuleesBegin = () => ({
	type: FETCH_DISPATCH_ANNULEES_BEGIN,
})

export const fetchDispatchAnnuleesSuccess = (depannages) => ({
	type: FETCH_DISPATCH_ANNULEES_SUCCESS,
	payload: depannages,
})

export const fetchDispatchAnnuleesError = (error) => ({
	type: FETCH_DISPATCH_ANNULEES_ERROR,
	payload: error,
})

// Onglet « Annulées » du dispatch : missions à l'état 80 (annulées par le
// bureau ou par le dépanneur), réactivables vers « prêt au dispatch ».
export function fetchDispatchAnnulees() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return Promise.resolve()
		let url = `${URL}api/depannages-dispatch?etat=80`
		dispatch(fetchDispatchAnnuleesBegin())
		return fetch(url, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchDispatchAnnuleesSuccess(json))
			})
			.catch(catchApiError(dispatch, fetchDispatchAnnuleesError))
	}
}

export const PUT_DEPANNAGE_DISPATCH_BEGIN = "PUT_DEPANNAGE_DISPATCH_BEGIN"
export const PUT_DEPANNAGE_DISPATCH_SUCCESS = "PUT_DEPANNAGE_DISPATCH_SUCCESS"
export const PUT_DEPANNAGE_DISPATCH_ERROR = "PUT_DEPANNAGE_DISPATCH_ERROR"
export const PUT_DEPANNAGE_DISPATCH_RESET = "PUT_DEPANNAGE_DISPATCH_RESET"

export const putDepannageDispatchBegin = () => ({
	type: PUT_DEPANNAGE_DISPATCH_BEGIN,
})

export const putDepannageDispatchSuccess = (depannageDispatch) => ({
	type: PUT_DEPANNAGE_DISPATCH_SUCCESS,
	payload: depannageDispatch,
})

export const putDepannageDispatchError = (error) => ({
	type: PUT_DEPANNAGE_DISPATCH_ERROR,
	payload: error,
})

export const putDepannageDispatchReset = () => ({
	type: PUT_DEPANNAGE_DISPATCH_RESET,
})

// GE-62 (B6) : corps d'une écriture web en delta — seuls les champs changés
// et la version lue (`base_version`) ; un champ écrit entre-temps par
// quelqu'un d'autre revient en 409 (jamais d'écrasement par une copie
// périmée, ex. une mission repassée à 20 depuis le planning).
export const corpsDelta = (dm, changes) =>
	JSON.stringify({ id: dm.id, base_version: dm.version || 0, ...changes })

// `silent` (défaut) : l'écran affiche lui-même l'erreur (putDepsToDispatch).
export function putDepannageDispatch(json, { silent = true } = {}) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(putDepannageDispatchBegin())
		return fetch(`${URL}api/depannages-dispatch`, {
			method: "put",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(putDepannageDispatchSuccess(json))
			})
			.catch(
				catchApiError(dispatch, putDepannageDispatchError, {
					silent,
				}),
			)
	}
}

export const POST_DEP_MISSION_BEGIN = "POST_DEP_MISSION_BEGIN"
export const POST_DEP_MISSION_SUCCESS = "POST_DEP_MISSION_SUCCESS"
export const POST_DEP_MISSION_ERROR = "POST_DEP_MISSION_ERROR"
export const POST_DEP_MISSION_RESET = "POST_DEP_MISSION_RESET"

export const postDepMissionBegin = () => ({
	type: POST_DEP_MISSION_BEGIN,
})

export const postDepMissionSuccess = (payload) => ({
	type: POST_DEP_MISSION_SUCCESS,
	payload,
})

export const postDepMissionError = (error) => ({
	type: POST_DEP_MISSION_ERROR,
	payload: error,
})

export const postDepMissionReset = () => ({
	type: POST_DEP_MISSION_RESET,
})

// Création / édition d'une mission (upsert api/depannages-dispatch). Remplace
// les fetch inline des anciens modals (erreurs avalées silencieusement).
export function postDepMission(json) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(postDepMissionBegin())
		return fetch(`${URL}api/depannages-dispatch`, {
			method: "post",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: json,
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(postDepMissionSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, postDepMissionError))
	}
}

// PIQUET (GE-47) — état du dispatch de piquet + forçage (interrupteur web).
// Le composant garde l'état en local : chaque thunk résout avec le nouvel
// état ({ouvert, source, jusqu_a, forcage_par}), ou null en cas d'erreur
// (toast via catchApiError).
const piquetRequete = (method, body) => async (dispatch, getState) => {
	const { token } = getState().navInfo.login
	return fetch(`${URL}api/depannages-piquet`, {
		method,
		headers: {
			Accept: "application/json, text/plain",
			"Content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		...(body ? { body: JSON.stringify(body) } : {}),
	})
		.then(handleErrors)
		.then((res) => res.json())
		.catch((err) =>
			catchApiError(dispatch, null, { silent: method === "get" })(
				err,
			).then(() => null),
		)
}

export const fetchPiquet = () => piquetRequete("get")

// ouvert : true = forcer ouvert, false = forcer fermé (jusqu'à la prochaine
// bascule du calendrier).
export const forcerPiquet = (ouvert) => piquetRequete("post", { ouvert })

export const revenirCalendrierPiquet = () => piquetRequete("delete")

// GE-62 (B2/B5) : écriture web en delta + base_version sur une mission. Pas
// de slice redux : le formulaire « Compléter » gère son état.
// → {ok: true, mission} | {ok: false, conflits, message} (409 champ par
// champ) ; toute autre erreur → toast, puis {ok: false}.
export function completerMission(id, baseVersion, delta) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		return fetch(`${URL}api/depannages-dispatch`, {
			method: "put",
			headers: {
				Accept: "application/json, text/plain",
				"Content-type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ id, base_version: baseVersion, ...delta }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((mission) => ({ ok: true, mission }))
			.catch((err) =>
				normalizeApiError(err).then((payload) => {
					// Revue phase B (🟠3) : conflits = 409 AVEC champs ; un 409 sans
					// champ (mission convertie, intégrité) a son message.
					if (
						payload.httpStatus === 409 &&
						Object.keys(payload.fields || {}).length > 0
					) {
						// Revue 5 : mission relue (base relevée sur elle).
						return fetch(`${URL}api/depannages-dispatch?id=${id}`, {
							headers: { Authorization: `Bearer ${token}` },
						})
							.then(handleErrors)
							.then((r) => r.json())
							.then((liste) => liste[0] || null)
							.catch(() => null)
							.then((mission) => ({
								ok: false,
								conflits: payload.fields,
								message: payload.message,
								mission,
							}))
					}
					return {
						ok: false,
						message: payload.message,
						httpStatus: payload.httpStatus,
					}
				}),
			)
	}
}
